import IconBase, { IconBaseProps } from "./IconBase";

const TableIconLarge = (props: IconBaseProps) => (
  <IconBase {...props} viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <rect
        width="14"
        height="14"
        x="1"
        y="1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        rx="2"
      />
      <g fill="currentColor">
        <path
          fillRule="nonzero"
          d="M3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm0-2h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
        />
        <path d="M5 2h2v12H5z" />
        <path d="M1 5h15v2H1z" />
      </g>
    </g>
  </IconBase>
);

export default TableIconLarge;
